
import { Component, Vue } from 'vue-property-decorator'
import { CollaboratorService } from "@/services/timetrack/CollaboratorService"
import Collaborator, { CollaborationState } from "@/types/collaborator/Collaborator"
import { ProjectService } from "@/services/timetrack/ProjectService"
import Project from "@/types/project/project"
import User from "@/types/account/user"
import { AccountService } from "@/services/account/AccountService"
import { BillingTypes } from "@/types/project/billing_types"

class InvitingProject {
  public constructor (init?:Partial<Project>) {
    Object.assign(this, init)
  }

  public id: string | null = null;
  public name: string | null = null;
  public description: string | null = null;
  public salary: number | null = null;
  public inviter: string | null = null;
  public collaboratorId: string | null = null;
}
@Component({
  filters: {
    formatCurrency (value: any) {
      return Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(value)
    }
  },
  components: {
  }
})
export default class CollaboratorInvitation extends Vue {
  private dialog = false
  private loading = false
  private projects: InvitingProject[] | null = null
  private collaborators: Collaborator[] | null = null

  private projectService = new ProjectService()
  private accountService = new AccountService()
  private collaborationService = new CollaboratorService()

  created () {
    this.fetchOpenInvitations()
  }

  private fetchOpenInvitations () {
    this.loading = true
    this.collaborationService.getProjectForCustomerByState(CollaborationState.invited)
      .then((collaborations: Collaborator[]) => {
        this.collaborators = collaborations
        if (this.collaborators.length > 0) {
          this.fetchProjects()
        } else {
          this.$emit('projectCreated')
          this.loading = false
          this.dialog = false
        }
      }).catch((error) => {
        this.loading = false
        this.$store.dispatch('error/setError', error)
      })
  }

  private fetchProjects () {
    const projectIds = this.collaborators?.map((collab) => { return collab.projectId })
    if (!projectIds || projectIds.length < 0) return
    this.projectService.getProjectsByIds(projectIds)
      .then((projects) => {
        this.fetchInviters(projects)
      }).catch((error) => {
        this.loading = false
        this.$store.dispatch('error/setError', error)
      })
  }

  private fetchInviters (projects: Project[]) {
    const inviters = this.collaborators?.map((collab) => { return collab.ownerId })
    if (!inviters || inviters.length < 0) return
    this.accountService.getUsersByIds(inviters)
      .then((inviters) => {
        this.projects = this.combineOriginalProjectWithInvitationSalary(projects, inviters)
        this.dialog = true
      }).catch((error) => {
        this.loading = false
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.loading = false
      })
  }

  private combineOriginalProjectWithInvitationSalary (projects: Project[], inviters: User[]) {
    if (!projects) return null
    const invitingProjects = projects.map((p) => {
      const project = new InvitingProject({
        ...p
      })
      const collabToProject = this.collaborators?.find((collab) => { return collab.projectId === project.id })
      const inviterToProject = inviters.find((inviter) => { return inviter.id === collabToProject?.ownerId })
      if (collabToProject && collabToProject.collaboratorSalary) {
        project.salary = collabToProject.collaboratorSalary
        project.inviter = inviterToProject?.firstName + ' ' + inviterToProject?.lastName
        project.collaboratorId = collabToProject.id
      }
      return project
    })
    return invitingProjects
  }

  private acceptInvitation (project: InvitingProject) {
    const storableProject = new Project({
      name: project.name,
      owner: false,
      active: true,
      billingType: BillingTypes.HOURLY,
      salary: project.salary,
      description: project.description
    })
    this.projectService.createProject(storableProject)
      .then((newProjectId: string) => {
        if (!project.collaboratorId) return
        this.collaborationService.setCollaborationNewProjectId(project.collaboratorId, newProjectId)
          .then(() => {
            this.setCollaborationState(project, CollaborationState.active)
          }).catch((error) => {
            this.loading = false
            this.$store.dispatch('error/setError', error)
          })
      }).catch((error) => {
        this.loading = false
        this.$store.dispatch('error/setError', error)
      })
  }

  private setCollaborationState (project: InvitingProject, state?: CollaborationState) {
    if (!project || !project.collaboratorId) return
    this.collaborationService.setCollaboratorState(project.collaboratorId, state || CollaborationState.declined)
      .then(() => {
        this.fetchOpenInvitations()
      }).catch((error) => {
        this.loading = false
        this.$store.dispatch('error/setError', error)
      })
  }
}
